module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-2400.8ea675d3.svg";